import { apiClient } from "./client";
import type { Branch, Room, Subject } from "@/types/branch";

export async function fetchBranches(): Promise<Branch[]> {
  const { data } = await apiClient.get<Branch[]>("/branches");
  return data;
}

export async function createBranch(payload: Partial<Branch>): Promise<Branch> {
  const { data } = await apiClient.post<Branch>("/branches", payload);
  return data;
}

export async function updateBranch(id: string, payload: Partial<Branch>): Promise<Branch> {
  const { data } = await apiClient.patch<Branch>(`/branches/${id}`, payload);
  return data;
}

export async function fetchRooms(branchId?: string): Promise<Room[]> {
  const { data } = await apiClient.get<Room[]>("/rooms", { params: { branchId } });
  return data;
}

export async function createRoom(payload: Partial<Room>): Promise<Room> {
  const { data } = await apiClient.post<Room>("/rooms", payload);
  return data;
}

export async function updateRoom(id: string, payload: Partial<Room>): Promise<Room> {
  const { data } = await apiClient.patch<Room>(`/rooms/${id}`, payload);
  return data;
}

export async function deleteRoom(id: string): Promise<void> {
  await apiClient.delete(`/rooms/${id}`);
}

export async function fetchSubjects(): Promise<Subject[]> {
  const { data } = await apiClient.get<Subject[]>("/subjects");
  return data;
}

export async function createSubject(payload: Partial<Subject>): Promise<Subject> {
  const { data } = await apiClient.post<Subject>("/subjects", payload);
  return data;
}

export async function updateSubject(id: string, payload: Partial<Subject>): Promise<Subject> {
  const { data } = await apiClient.patch<Subject>(`/subjects/${id}`, payload);
  return data;
}
